import React from 'react'
import { apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { isEmpty } from 'lodash'
import useToastContext from 'hooks/useToastContext'
import { AiFillEdit, AiFillEye } from 'react-icons/ai'
import { useTranslation } from 'react-i18next'
import { BsArrowUpShort } from 'react-icons/bs'
import helper from '../../utils/helpers'
import TableHeaderCell from 'components/reusable/TableHeaderCell'

const Table = ({
  users,
  getAllUser,
  handelEdit,
  handleUserView,
  user,
  page,
  sort,
  setSort
}) => {
  const { t } = useTranslation()
  const notification = useToastContext()

  const handelStatusChange = async item => {
    try {
      const payload = {
        status: item?.status === 'inactive' ? 'active' : 'inactive'
      }
      const path = `${apiPath.changeUserStatus}/${item?._id}`
      const result = await apiPut(path, payload)
      if (result?.status === 200) {
        notification.success(result.data.message)
        getAllUser()
      }
      // }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }

  return (
    <div className='p-3'>
      <div className='overflow-x-auto relative rounded-lg border'>
        <table className='w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 '>
          <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
            <tr>
              <TableHeaderCell text={t('SR_NO')} />
              <TableHeaderCell text={t('COMPANY_ID')} />
              <TableHeaderCell text={t('COMPANY_NAME')} />
              <TableHeaderCell text={t('MOBILE_NUMBER')} />
              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (sort.sort_key === 'email' && sort.sort_type === 'asc') {
                    setSort({
                      sort_key: 'email',
                      sort_type: 'desc'
                    })
                  } else {
                    setSort({
                      sort_key: 'email',
                      sort_type: 'asc'
                    })
                  }
                }}
              >
                <div className='flex justify-left'>
                  <span>{t('OFFICIAL_EMAIL_ID')}</span>
                  <span>
                    {sort.sort_key === 'email' && sort.sort_type === 'asc' && (
                      <BsArrowUpShort className='w-4 h-4' />
                    )}
                    {sort.sort_key === 'email' && sort.sort_type === 'desc' && (
                      <BsArrowUpShort className='w-4 h-4 rotate-180' />
                    )}
                  </span>
                </div>
              </th>
              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (
                    sort.sort_key === 'createdAt' &&
                    sort.sort_type === 'asc'
                  ) {
                    setSort({
                      sort_key: 'createdAt',
                      sort_type: 'desc'
                    })
                  } else {
                    setSort({
                      sort_key: 'createdAt',
                      sort_type: 'asc'
                    })
                  }
                }}
              >
                <div className='flex justify-start'>
                  <span>{t('CREATED_DATE')}</span>
                  <span>
                    {sort.sort_key === 'createdAt' &&
                      sort.sort_type === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                    {sort.sort_key === 'createdAt' &&
                      sort.sort_type === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                  </span>
                </div>
              </th>
              <TableHeaderCell text={t('COUNTRY')} />
              <TableHeaderCell text={t('CITY')} />
              <TableHeaderCell text={t('SUBSCRIBED_UNSUBSCRIBED')} />

              {(user?.permission?.[1]?.add ||
                user?.permission?.length === 0) && (
                <th scope='col' className='py-3 px-6 text-center'>
                  {t('O_STATUS')}
                </th>
              )}
              <TableHeaderCell text={t('O_ACTION')} />
            </tr>
          </thead>
          <tbody>
            {users &&
              users?.map((item, i) => (
                <tr
                  key={i}
                  className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                >
                  <th
                    scope='row'
                    className='py-4 px-6 border-r font-medium text-gray-900  dark:text-white'
                  >
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className='py-4 px-6 border-r'>{item?.companyId} </td>
                  <td className='py-4 px-6 border-r'>{item?.companyName}</td>
                  <td className='py-4 px-6 border-r text-left'>
                    {item?.mobileNumber}
                  </td>
                  <td className='py-4 px-6 border-r text-left'>
                    {item?.officialEmail}
                  </td>
                  <td className='py-4 px-6 border-r '></td>
                  {(user?.permission?.[1]?.add ||
                    user?.permission?.length === 0) && (
                    <td className='py-4 px-6 border-r text-center'>
                      <label
                        className='inline-flex relative items-center cursor-pointer'
                        title={`${
                          item?.status === 'active' ? 'Active' : 'Inactive'
                        }`}
                      >
                        <input
                          type='checkbox'
                          className='sr-only peer'
                          checked={item?.status === 'active'}
                          onChange={e =>
                            helper.alertFunction(
                              `Are you sure you want to ${
                                e.target.checked ? 'active' : 'inactive'
                              } "${item.first_name} ${item?.last_name}"?`,
                              item,
                              handelStatusChange
                            )
                          }
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                      </label>
                    </td>
                  )}
                  <td className='py-4 px-6 border-l'>
                    <div className=''>
                      <ul className='flex justify-center'>
                        {(user?.permission?.[1]?.add ||
                          user.permission?.length === 0) && (
                          <li
                            onClick={() => handelEdit(item)}
                            className='px-2 py-2 hover:bg-white hover:text-LightBlue'
                          >
                            <a
                              title={t('O_EDIT_USER')}
                              className='hover:text-blue-700 transition duration-150 ease-in-out'
                              data-bs-toggle='tooltip'
                            >
                              {' '}
                              <AiFillEdit className='cursor-pointer w-5 h-5 text-slate-600' />
                            </a>
                          </li>
                        )}
                        {(user?.permission?.[1]?.view ||
                          user.permission?.length === 0) && (
                          <li
                            onClick={() => handleUserView(item)}
                            className='px-2 py-2 hover:bg-white hover:text-LightBlue'
                          >
                            <a title={t('O_VIEW_USER')}>
                              {' '}
                              <AiFillEye className='cursor-pointer w-5 h-5 text-slate-600' />{' '}
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(users) ? (
              <tr className='bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700'>
                <td className='py-4 px-6 border-r' colSpan={12}>
                  {t('O_NO_RECORD_FOUND')}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Table
